//import * as log from '@egt/egt-library/dist/utils/log'
import { Stage, StageConfig } from './stage/Stage'

//@log.decorator
export class Main {
    // log
    // warn
    private _egtLib: any = null
    private _stage: Stage = null
    private _gin: number = -1
    private _engine: string = null
    private _isMobile: boolean = false
    private _stageOptions: StageConfig = null
    private _isEngineUsingNamespaces: boolean = false
    private _game: any = null
    private _isUsingSingleCodeBase: boolean = false

    constructor(
        gin: string,
        engine: string,
        isMobile = true,
        stageOptions: StageConfig = undefined,
        isUsingSingleCodeBase = false,
        shouldNotUsePixiResolution = false
    ) {
        this._gin = +gin
        this._engine = engine
        this._isMobile = isMobile
        this._stageOptions = stageOptions
        this._isUsingSingleCodeBase = isUsingSingleCodeBase

        let additionalHeightOnSmallDevices = 0

        if (!this._engine) {
            this.abort('No Engine')
            return
        }

        const mainTag = $('#gpts')
        mainTag.on('click', function () {
            window.focus()
        })
        window.focus()

        const autoRouletteGins = [3, 6, 8, 11, 12, 13, 14, 15, 16, 17, 18, 19, 21, 22, 23, 20201]
        if (autoRouletteGins.indexOf(this._gin) > -1) {
            additionalHeightOnSmallDevices = 50
        }

        const namespacedGins = [
            3,
            6,
            8,
            11,
            12,
            13,
            14,
            15,
            16,
            17,
            18,
            19,
            21,
            22,
            23,
            20201,
            591,
            500,
            20,
            550, // slot roulette gins
        ]

        this._isEngineUsingNamespaces = namespacedGins.indexOf(this._gin) !== -1
        if (this._isUsingSingleCodeBase || this._isMobile) {
            if (this._isEngineUsingNamespaces) {
                this._egtLib = window['com']['egt']['library']
            } else {
                this._egtLib = window['egtLibrary']
            }
        } else {
            this._egtLib = window['com']['egt']['library']
        }

        this._stage = new Stage(
            this._egtLib,
            this._isMobile,
            this._stageOptions,
            this._isUsingSingleCodeBase,
            shouldNotUsePixiResolution,
            additionalHeightOnSmallDevices
        )

        window.addEventListener('message', (event) => {
            if (typeof event.data === 'object' && event.data.id === 'EventForGame' && this._game != null) {
                if (event.data.data.command == 'show') {
                    event.data.data.usedSafePadding = this._stage.usedSafePadding
                }

                this._game.data = event.data.data
            }
        })
    }

    createEngine() {
        if (this._isUsingSingleCodeBase || this._isMobile) {
            try {
                if (this._isEngineUsingNamespaces) {
                    this._game = new (window as any).com.egt[this._engine.toLowerCase()].Main()
                    this._stage.stage.addChild(this._game)
                } else {
                    this._game = new (window as any)[`Mobile${this._engine}`].Main()
                }
            } catch (e) {
                this.abort(e)
                return
            }
        } else {
            try {
                this._game = new (window as any).com.egt[this._engine.toLowerCase()].Main()
            } catch (e) {
                this.abort(e)
                return
            }
            this._stage.stage.addChild(this._game)
        }

        const events = this._game.events.slice()
        events.push('CompleteIntegration')
        events.push('IntegratedProgress')
        events.push('FailIntegration')
        events.push('GameReady')

        events.forEach((eventName) => {
            this._game.addEventListener(eventName, (event) => {
                parent.postMessage(
                    {
                        bet: event.bet,
                        event: event.type,
                        gin: this._gin,
                        data: event.data,
                    },
                    '*'
                )
            })
        })

        parent.postMessage(
            {
                event: 'IframeLoaded',
                gin: this._gin,
            },
            '*'
        )
    }

    private abort(error?: any) {
        console.error('GAME_INIT_ERROR: ', error)
        parent.postMessage(
            {
                event: 'FailIntegration',
                gin: this._gin,
                data: {},
            },
            '*'
        )
    }
}

export enum MobileVariant {
    NO_MOBILE,
    OLD,
    REDESIGNED,
    ROULETTE_MOBILE,
}
